import { TopicKey, TOPIC } from "./ws-constants";

type RequestFn = <T = any>(action: string, payload?: any, timeoutMs?: number) => Promise<T>;

// Subscribe without user_id - server injects from authorizer
export const makeSubscribeApi = (request: RequestFn) => {
  const subscribeTopic = async (topic: TopicKey, filters?: Record<string, any>) => {
    const payload: any = { topic };
    if (filters && Object.keys(filters).length) payload.filters = filters;
    const result = await request("subscriptions.subscribe", payload, 8000);
    return result;
  };
  const unsubscribeTopic = async (topic: TopicKey) => {
    await request("subscriptions.unsubscribe", { topic }, 8000);
  };
  const subscribeNotifications = async (categories?: string[]) => {
    const payload: any = { topic: TOPIC.NOTIFICATIONS };
    if (Array.isArray(categories) && categories.length) payload.categories = categories;
    await request("subscriptions.subscribe", payload, 8000);
  };
  return { subscribeTopic, unsubscribeTopic, subscribeNotifications };
};